import React from "react";
import { Grid, Skeleton } from "@mui/material";

const ComplaintsRootCauses = ({
  rootCauses,
  rootCausesLoading,
  mode,
  onRootCauseClick,
}: any) => {
  // Helper function to clean the root cause text
  const cleanRootCause = (text: string) => {
    return text.replace(/\s*\(.*?\)\s*/g, "").trim(); // Removes text inside parentheses
  };

  // Calculate the total count of root causes for percentage calculation
  const totalCount = rootCauses.reduce(
    (acc: any, cause: any) => acc + cause.count,
    0
  );

  return (
    <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ marginTop: "10px" }}>
      <Grid
        container
        spacing={2}
        sx={{ paddingLeft: "10px", paddingRight: "10px" }}
      >
        <div className='complaints-detailed-root-cause-table'>
          <div
            style={{
              display: "flex",
              backgroundColor: mode === "dark" ? "#2E2E38" : "#f0f0f0",
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <div style={{ width: "70%", fontWeight: "bold" }}>Root Cause</div>
            {/* <div
              style={{ width: "20%", fontWeight: "bold", textAlign: "left" }}
            >
              Count
            </div> */}
            <div
              style={{ width: "30%", fontWeight: "bold", textAlign: "left" }}
            >
              Percentage
            </div>
          </div>

          <div className='complaints-detailed-root-cause-table-list'>
            {!rootCausesLoading && rootCauses && rootCauses.length > 0
              ? rootCauses.map((rootCause: any, index: number) => {
                  const cleanedRootCause = cleanRootCause(rootCause.root_cause);
                  const percentage =
                    totalCount > 0
                      ? ((rootCause.count / totalCount) * 100).toFixed(2)
                      : 0;

                  return (
                    <div
                      key={index}
                      style={{
                        maxHeight: "200px",
                        cursor: "pointer",
                        background: mode === "dark" ? "#747480" : "#f9f9f9",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                      }}
                      onClick={() =>
                        onRootCauseClick(`call regarding ${cleanedRootCause}`)
                      }
                    >
                      <div
                        style={{
                          padding: "10px",
                          textAlign: "left",
                          width: "70%",
                        }}
                      >
                        {cleanedRootCause}
                      </div>
                      {/* <div
                        style={{
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                          width: "20%",
                        }}
                      >
                        {rootCause.count}
                      </div> */}
                      <div
                        style={{
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                          width: "30%",
                        }}
                      >
                        {percentage} %
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
          {/* Fallback Skeleton Loader */}
          {rootCausesLoading && (
            <div className='complaints-table-skeleton-wrapper'>
              <Skeleton height='40px' width='100%' />
              <Skeleton height='40px' width='100%' />
              <Skeleton height='40px' width='100%' />
              <Skeleton height='40px' width='100%' />
            </div>
          )}
          {!rootCausesLoading && (!rootCauses || rootCauses.length === 0) && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No Data Found
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default ComplaintsRootCauses;
